import { render, staticRenderFns } from "./ed-my-info-admin.component.vue?vue&type=template&id=3f4ac16a&scoped=true&"
import script from "./ed-my-info-admin.component.ts?vue&type=script&lang=ts&"
export * from "./ed-my-info-admin.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-my-info-admin.component.scss?vue&type=style&index=0&id=3f4ac16a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4ac16a",
  null
  
)

export default component.exports